import {API_URL, THEME_COLOR, CMS_URL, numberWithCommas} from "../constant"
import React from 'react';
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick"
import { BrowserRouter as Router, Link } from 'react-router-dom';
import InfiniteScroll from "react-infinite-scroller";

import banner1 from "../logo.svg"
import banner2 from "../images/bst_banner.jpg"

import "./Search.css";


class Search extends React.Component{

    constructor(props){
        super(props)

        const search = props.location.search;
        const query = new URLSearchParams(search).get('q');
        const category = new URLSearchParams(search).get('c');

        this.state= {
            searchq: query,
            category : category,
            itemPage : 0,
            hasMore:  (query && query != "") || (category && category != ""),
            items: [],
            isLoading: false
        }

        this.timer = null
        // console.log(this.state.category)
    }

    async componentDidMount(){
        
    }

    changeSearch(e){
        let tstate = {...this.state};
        tstate["searchq"] = e.target.value;
        this.setState(tstate);
        // if(this.timer)
        //     clearTimeout(this.timer)
        // this.timer = setTimeout(async ()=>{
        //     this.setState({
        //         isLoading: false,
        //         hasMore: true,
        //         items: [],
        //         searchq: e.target.value,
        //         itemPage: 0
        //     })
        //     await this.loadMore();
        // }, 2000)
    }

    keyDownSearch(e){
        if(e.code == "Enter"){
            let tstate = {...this.state};
            tstate["isLoading"] = false;
            tstate["hasMore"] = true;
            tstate["itemPage"] = 0;
            tstate["items"] = [];
            this.setState(tstate);
            setTimeout(()=>{this.loadMore()},100);
        }
    }



    async loadMore(){
        if(!this.state.isLoading && ( (this.state.searchq !== "" && this.state.searchq !== null) || (this.state.category !== 0 && this.state.category !== null) ) ){
            let tstate = {...this.state}
            tstate["itemPage"] = tstate["itemPage"] + 1
            tstate["isLoading"] = true;
            await this.setState(tstate);
            // await this.setState({
            //     itemPage: this.state.itemPage+1,
            //     // hasMore: false,
            //     isLoading: true
            // })
            var myHeaders = new Headers();
            myHeaders.append("x-wh", localStorage.getItem("wh"));
            var urlencoded = new URLSearchParams();
    
            var requestOptions = {
                method: 'GET',
                // body: urlencoded,
                headers: myHeaders,
                redirect: 'follow'
            };
            
            let params = "";
            if(this.state.searchq && this.state.searchq !== "")
                params += "&q="+this.state.searchq;
            if(this.state.category && this.state.category !== "")
                params += "&c="+this.state.category;
            fetch(`${API_URL}api/search?p=${this.state.itemPage}&rp=10${params}`, requestOptions)
            .then(response => response.json())
            .then(res=>{
                let items = this.state.items;
                res.data.map((value, index)=>{
                    let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                    if(value.ImageName){
                        imgurl = `${CMS_URL}/images/upload/product/${value.Code}/${value.ImageName}`;
                    }
                    items.push(
                        <div className="home-item" key={`search-`+value.ItemUnitID}>
                            <Link to={`/item/${value.ItemUnitID}`} className="black-text">
                                <div style={{position:"relative", width:"100%", paddingTop:"100%"}}>
                                    <img className="home-item-image" src={imgurl} />
                                </div>
                                <div style={{flex:"1 0 auto", display:"flex", flexDirection:"column", padding:".625rem",overflow:"hidden"}}>
                                    <div style={{flex:"1 0 auto", display:"flex", flexDirection:"column", padding:".625rem",overflow:"hidden"}}>
                                        <div style={{flexGrow: "1", minHeight: "1.75rem"}}>
                                            <div className="home-item-title">{value.Name + " " + ((value.Color) ? value.Color: "")}</div>
                                        </div>
                                    </div>
                                    <div className="home-item-detail">
                                        <div className="home-item-price">
                                            <span style={{fontSize:".75rem",color:`${THEME_COLOR}`}}>Rp</span>
                                            <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontSize:"1rem",color:THEME_COLOR}}>{numberWithCommas(value.CatalogPrice)}</span>
                                        </div>
                                        <div className="home-item-sold">{value.Sales} Sold</div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    )
                })
                tstate = {...this.state};
                tstate["items"] = items;
                tstate["isLoading"] = false;
                tstate["hasMore"] = res.data.length > 0;
                this.setState(tstate);
                // this.setState({
                //     items: items,
                //     isLoading: false,
                //     hasMore: res.data.length > 0
                // })
            })
            .catch(error => {
                console.log(error)
                let tstate = {...this.state};
                tstate["isLoading"] = false;
                this.setState(tstate);
                this.setState({isLoading: false})
            });
        }
    }

    render(){
      
        return(
            <React.StrictMode>
                {/* <Header /> */}
                <div className="">
                    <div className="home-container">
                        <nav>
                            <div className={`nav-wrapper deep-orange darken-1`}>
                                <form>
                                    <div className="input-field">
                                    {/* <input id="search" type="search" placeholder="Search..." name="q" onChange={(e)=> this.changeSearch(e)} /> */}
                                    <input id="search" type="search" placeholder="Search..." name="q" value={this.state.searchq} onChange={(e) => this.changeSearch(e)} onKeyDown={(e) => this.keyDownSearch(e)}/>
                                    <label className="label-icon" htmlFor="search"><i className="material-icons">search</i></label>
                                    <i className="material-icons">close</i>
                                    </div>

                                </form>
                            </div>
                        </nav>
                    </div>
                    
                    <InfiniteScroll
                        pageStart={this.state.itemPage}
                        loadMore={this.loadMore.bind(this)}
                        hasMore={this.state.hasMore}
                        loader={
                            ( (!this.state.searchq || this.state.searchq === "") && (!this.state.category || this.state.category === 0)) ?
                            (
                                <div></div>
                            ):
                            (
                                <div style={{width: "100%", textAlign:"center"}}>
                                    <div className="preloader-wrapper big active">
                                        <div className="spinner-layer spinner-blue-only">
                                            <div className="circle-clipper left">
                                                <div className="circle"></div>
                                            </div>
                                            <div className="gap-patch">
                                                <div className="circle"></div>
                                            </div>
                                            <div className="circle-clipper right">
                                                <div className="circle"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        children={``}
                    >
                        <div className="" style={{display:"flex",flexWrap:"wrap",paddingBottom:"80px"}}>
                            {this.state.items}
                        </div>
                    </InfiniteScroll>
                </div>
                <Footer />
            </React.StrictMode>
        );
    }
}

export default Search;
